<template>
  <div class="container-top mt-5" :class="{ 'container-wide': lgAndUp || xlAndUp }">
    <div class="">
      <div
        class="d-flex flex-column flex-md-row justify-content-md-between my-3"
      >
        <div class="first-timers-tex" v-if="true">
          <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
            Donation & Offerings
             <!-- Offering -->
          </div>
          <div class="d-flex align-items-center w-100 cursor-pointer">
            <span class="mr-1 text-white">
              <VideoPlayIcon />
            </span>
            <span class="s-13 text-dak font-weight-600">
              <u>
                {{
                  navigatorLang === "en-US"
                    ? "Watch Video"
                    : $t("people.watchVideo")
                }}
              </u>
            </span>
          </div>
        </div>

        <div class="d-flex flex-wrap flex-sm-nowrap mt-3 mt-sm-0" v-if="true">
          <el-dropdown
            trigger="click"
            class="align-items-center justify-content-center w-100 d-flex ml-md-3 ml-0 default-btn2 py-0 m-0 border"
            style="height: 2.2rem"
          >
            <span
              class="el-dropdown-link w-100 primary--text text-center font-weight-600"
            >
              {{ navigatorLang === "en-US" ? "More" : $t("people.more") }}
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <router-link
                    to="/tenant/payment"
                    class="text-black text-decoration-none w-100 mt-2 mt-sm-0"
                  >
                    Donation Forms
                  </router-link>
                </el-dropdown-item>
                <!-- <el-dropdown-item class="text-black">
                  <router-link
                    to=""
                    class="col-md-12 align-items-center mr-3 text-decoration-none text-dak px-0"
                  >
                    <span class="d-flex align-items-center text-black">
                      Campaigns
                    </span>
                  </router-link>
                </el-dropdown-item> -->
                <el-dropdown-item class="text-black">
                  <router-link
                    to="/tenant/contributionCategory"
                    class="col-md-12 align-items-center mr-3 text-decoration-none text-dak px-0"
                  >
                    <span class="d-flex align-items-center text-black">
                      Offering & Donation items
                    </span>
                  </router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <router-link to="/tenant/addoffering" class="w-100 no-decoration">
            <el-button
              round
              :color="primarycolor"
              class="header-btn text-white w-100 ml-0 ml-sm-2 mt-sm-0 mt-3"
              >Record Offering</el-button
            >
          </router-link>
        </div>
        <div class="d-flex head-button" v-if="false">
          <router-link to="/tenant/onlinedonation" class="w-100 mr-0 mr-md-2">
            <el-button
              round
              size="large"
              class="header-btn secondary-button w-100"
              >Online Donation</el-button
            >
          </router-link>
          <router-link
            to="/tenant/contributionCategory"
            class="mr-0 mt-sm-0 mt-2 mr-md-2 w-100"
          >
            <el-button
              round
              size="large"
              class="w-100 header-btn secondary-button"
              >View Offering Items</el-button
            >
          </router-link>
          <router-link to="/tenant/addoffering" class="w-100 mt-2 mt-sm-0">
            <el-button
              round
              size="large"
              :color="primarycolor"
              class="header-btn w-100"
              >Add Offering</el-button
            >
          </router-link>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <el-skeleton class="w-100" animated v-if="loading">
        <template #template>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 20px;
            "
          >
            <el-skeleton-item
              variant="text"
              style="width: 240px; height: 240px"
            />
            <el-skeleton-item
              variant="text"
              style="width: 240px; height: 240px"
            />
          </div>
          <el-skeleton
            class="w-100 mt-5"
            style="height: 25px"
            :rows="20"
            animated
          />
        </template>
      </el-skeleton>

      <div
        v-if="
          contributionTransactions &&
          contributionTransactions.length > 0 &&
          !loading &&
          !networkError
        "
      >
        <OfferingList
          :contributionTransactions="contributionTransactions"
          @marked="removeMultipleOffering"
          @get-pages="getOfferingPages"
          @contri-transac="updateTransac"
          :totalItem="totalItem"
        />
      </div>
      <div
        class="no-person"
        v-else-if="
          contributionTransactions &&
          contributionTransactions.length === 0 &&
          !loading &&
          !networkError
        "
      >
        <div class="empty-img">
          <p><img src="../../../assets/people/people-empty.svg" alt="" /></p>
          <p class="tip">You haven't added any offering transaction yet</p>
          <el-button
            :color="primarycolor"
            @click="addOffering"
            class="ml-2 header-btn"
            round
            >Add Offering
          </el-button>
        </div>
      </div>
      <div v-else-if="networkError" class="adjust-network">
        <img src="../../../assets/network-disconnected.png" />
        <div>Opps, Your internet connection was disrupted</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, inject } from "vue";
// import { useStore } from 'vuex'
import store from "../../../store/store";
import router from "../../../router";
// import axios from "@/gateway/backendapi"
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import OfferingList from "./OfferingList";
import VideoPlayIcon from "../../../components/svg/VideoPlayIcon.vue";
export default {
  components: {
    OfferingList,
    VideoPlayIcon,
  },
  setup() {
    const contributionTransactions = ref(
      store.getters["contributions/contributionsList"].data
    );
    const { lgAndUp, xlAndUp } = deviceBreakpoint();
    const primarycolor = inject("primarycolor");
    const totalItem = ref(
      store.getters["contributions/contributionsList"].totalItems
    );
    const loading = ref(false);
    const networkError = ref(false);
    const navigatorLang = ref(navigator.language);
    const videoURL = ref(
      "https://www.youtube.com/embed/JSI7IksFUNQ?si=updEhHP30u4H1Z40"
    );
    const showAddVideo = ref(false);
    const watchVideo = () => {
      showAddVideo.value = true;
    };
    const addOffering = () => {
      router.push("/tenant/addoffering");
    };

    const removeMultipleOffering = (payload) => {
      contributionTransactions.value = contributionTransactions.value.filter(
        (item) => {
          const y = payload.findIndex((i) => i.id === item.id);
          if (y >= 0) return false;
          return true;
        }
      );
    };
    const getContributionTransactions = async () => {
      try {
        loading.value = true;
        await store
          .dispatch("contributions/setContributionList")
          .then((res) => {
            contributionTransactions.value = res.data;
            totalItem.value = res.totalItems;
            loading.value = false;
          });
      } catch (error) {
        console.log(error);
        loading.value = false;
        if (err.toString().toLowerCase().includes("network error")) {
          networkError.value = true;
        } else {
          networkError.value = false;
        }
      }
    };

    onMounted(() => {
      if (
        !contributionTransactions.value ||
        (contributionTransactions.value &&
          contributionTransactions.value.contribution &&
          contributionTransactions.value.contribution.length == 0)
      ) {
        getContributionTransactions();
      }
    });

    const getOfferingPages = (payload) => {
      contributionTransactions.value = payload.data;
    };

    const updateTransac = (payload) => {
      contributionTransactions.value.splice(payload, 1);
    };
    return {
      addOffering,
      navigatorLang,
      videoURL,
      showAddVideo,
      watchVideo,
      contributionTransactions,
      primarycolor,
      xlAndUp,
      lgAndUp,
      loading,
      getOfferingPages,
      updateTransac,
      totalItem,
      networkError,
      removeMultipleOffering,
    };
  },
};
</script>

<style scoped>
.page-header {
  font: normal normal 800 29px Nunito sans;
}

.head-button {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 577px) {
  .head-button {
    flex-direction: column;
    align-items: center;
  }

  .more {
    margin-right: 0;
  }

  .add-btn {
    margin-top: 10px;
  }
}

@media (max-width: 575px) {
  .head-button {
    display: flex;
    /* flex-direction: row; */
    /* align-items: center; */
    justify-content: center;
  }

  /* .add-btn,
  .more {
    margin-top: 10px;
  } */
}

.add-btn {
  width: 180px;
  background: #0040ff;
  border-radius: 22px;
  color: #ffffff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  text-decoration: none;
}

.no-person {
  height: 80vh;
  display: flex;
  text-align: center;
}

.empty-img {
  width: 30%;
  min-width: 397px;
  margin: auto;
}

.empty-img img {
  width: 100%;
  max-width: 200px;
}

@media (max-width: 767px) {
  .first-timers-text {
    text-align: start;
  }
  .head-button {
    display: flex;
    justify-content: center;
  }
}
</style>
